import * as React from 'react';
import { useMemo, useState } from 'react';

import Toolbar from '@mui/material/Toolbar';

import { makeStyles } from '@mui/styles';
import { Badge, Tab, Tabs } from '@mui/material';
import { CollectorScope, CollectorSettingScope } from 'graphql/types';
import { useMessages } from 'modules/intl';
import { useEnabledGroupTypes } from 'modules/Settings/hooks/useEnabledGroupTypes';
import { CompanyCollectorSettingsPage } from './Setting/CompanyCollectorSettingsDialog/CompanyCollectorSettingsPage';
import { useCollectorSetting } from './hooks';

const useStyles = makeStyles((theme) => ({
  toolBar: {
    width: '100%'
  },
  tabs: {
    width: theme.spacing(25)
  },
  badge: {
    '& .MuiBadge-badge': {
      right: theme.spacing(-1)
    }
  }
}));

type collectorManagePageProps = {
  installationObj: Record<string, string>;
  scope: string[];
  retryUrl: string;
  hasTenantError: boolean;
};

const messages = ['collectorType.self', 'collectorType.company'];

export const CollectorManagePage: React.FC<collectorManagePageProps> = ({
  installationObj,
  scope,
  retryUrl,
  hasTenantError
}: collectorManagePageProps) => {
  const classes = useStyles();

  const manageMessages = useMessages(messages);

  const stateInitialValue = useMemo(() => {
    if (installationObj && Object.keys(installationObj).length == 2) {
      return CollectorSettingScope.Tenant;
    } else if (installationObj && Object.keys(installationObj).length === 1)
      return Object.keys(installationObj)[0];
    else return '';
  }, [installationObj]);
  const [value, setValue] = useState<string>(stateInitialValue);

  const { data: enabledGroupTypesData, loading } = useEnabledGroupTypes();
  const enabledGroupTypes = useMemo(
    () =>
      !loading &&
      enabledGroupTypesData &&
      enabledGroupTypesData.enabledGroupTypes?.items
        ? enabledGroupTypesData.enabledGroupTypes?.items
        : [],
    [enabledGroupTypesData, loading]
  );

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const {
    data: collectorSettingData,
    loading: colletorSettingLoading
  } = useCollectorSetting({
    installId: installationObj[CollectorSettingScope.Tenant]
  });

  return (
    <div data-testid="collector-manage-page">
      {scope?.length > 1 && installationObj[CollectorScope.Tenant] && (
        <Toolbar className={classes.toolBar}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="fullWidth"
            className={classes.tabs}
          >
            <Tab
              label={
                <Badge
                  color="secondary"
                  variant="dot"
                  className={classes.badge}
                  invisible={!hasTenantError}
                >
                  {manageMessages['collectorType.company']}
                </Badge>
              }
              value={CollectorSettingScope.Tenant}
              disabled={!installationObj[CollectorSettingScope.Tenant]}
            />
          </Tabs>
        </Toolbar>
      )}
      <div>
        <div>
          {value === CollectorSettingScope.Tenant && (
            <CompanyCollectorSettingsPage
              enabledGroupTypes={enabledGroupTypes}
              installId={installationObj[CollectorSettingScope.Tenant]}
              loading={colletorSettingLoading}
              data={collectorSettingData}
              retryUrl={retryUrl}
            />
          )}
        </div>
      </div>
    </div>
  );
};
